<script setup lang="ts">
import { DateTime } from "luxon";
import { useQuery, useResult } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { platform } from "@/libs/environment";

const disabled = true; // Set this to true to disable the alert

function customDateRelative(dateIsoFormat: string): string | null {
  return DateTime.fromISO(dateIsoFormat)
    .setLocale("pt-BR")
    .toRelative({
      unit: ["hours", "minutes", "seconds"],
    });
}

const { result: myLastSubscriptiomResult } = useQuery(
  gql`
    query MyLastSubscription {
      myLastSubscription {
        id
        validUntil
        trial
      }
    }
  `,
  {},
  {
    fetchPolicy: "no-cache",
  }
);
const subscription = useResult(
  myLastSubscriptiomResult,
  null,
  (data) => data.myLastSubscription
);
const dateLimit = DateTime.now().plus({ days: 7 }).endOf("day").toUTC().toISO();
const now = DateTime.now().toUTC().toISO();
const promotionalText =
  "Aproveite nossa promoção de lançamento com até 60% de desconto.";
const promotionIsValid =
  false && DateTime.now() < DateTime.fromISO("2022-06-08T23:59:59.999-03:00");
</script>

<template>
  <div
    v-if="
      !disabled &&
      subscription &&
      subscription.trial &&
      subscription.validUntil < dateLimit
    "
    class="alert"
    :class="{
      'alert-warning': subscription.validUntil >= now,
      'alert-danger': subscription.validUntil < now,
    }"
    role="alert"
  >
    <h4 class="alert-heading">Atenção!</h4>
    <div>
      <p>
        Seu período de testes
        {{ subscription.validUntil < now ? "acabou" : "acaba" }}
        <strong>{{ customDateRelative(subscription.validUntil) }}</strong
        >.
        <template v-if="promotionIsValid">
          {{ promotionalText }}
        </template>
        <template v-else>
          Não perca o seu acesso a plataforma que ajuda lojistas de todo Brasil
          a encontrar as melhores ofertas abaixo da FIPE.
        </template>
      </p>
    </div>
    <router-link class="btn btn-primary" to="/user/new-subscription">
      Ver planos de assinatura
    </router-link>
  </div>
</template>
